import React from "react";
import { Container } from "react-bootstrap";
import PrivacyPolicy from "./PrivacyPolicy";
import AdSense from "./AdSense";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto py-3" data-bs-theme="auto">
      {/* AdSense Display Ad */}
      <div className="mb-4">
        <AdSense
          adSlot="footer-ad"
          style={{ display: "block", textAlign: "center" }}
        />
      </div>

      <Container className="text-center text-muted">
        <div className="d-flex flex-wrap justify-content-center align-items-center gap-3">
          <span>© {currentYear} SourdoughMath</span>
          <span>•</span>
          <PrivacyPolicy />
          <a
            href="https://hotplate.com/bcbakestally"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Sourdough in Tallahassee, FL
          </a>
          <a
            href="https://CFBTrack.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            CFB Track (For all of you college football data needs)
          </a>
          <a href="https://mapifystats.com">MapifyStats</a>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
